import { compose, withHandlers, withState } from 'recompose';
import copy from 'copy-to-clipboard';

export const t = {
  copied: 'Copied to clipboard!',
};

export const enhance = compose(
  withState('copied', 'setCopied', false),
  withHandlers({
    handleClick:
      ({ onClick, setCopied, text }) =>
      (e) => {
        e.stopPropagation();
        copy(text);
        onClick && onClick(e);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      },
  })
);
